/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {GenericModelUtils} from "../../../Utils/GenericModelUtils";

export function LatLongFieldViewer(props) {

	const {FieldDefs, FieldDef,  Data} = props;
	const {keyPrefix = '', group: fieldDefGroup} = FieldDef;
	const latitudeFieldKey = `${keyPrefix}latitude`;
	const longitudeFieldKey = `${keyPrefix}longitude`;

	const latitudeField = GenericModelUtils.findFieldDefinition(FieldDefs, fieldDefGroup, latitudeFieldKey);
	const longitudeField = GenericModelUtils.findFieldDefinition(FieldDefs, fieldDefGroup, longitudeFieldKey);

	const latitudeValue = latitudeField?.getter(Data) ?? null;
	const longitudeValue = longitudeField?.getter(Data) ?? null;

	if(latitudeValue != null || longitudeValue != null) {
		return `${latitudeValue}°, ${longitudeValue}°`;
	}

	return "";
}
